<div id="reportingDashboard" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="reportType" (closeEvent)="close()" [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="downloadReports()"></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title">
          {{reportType}} 
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      
        <div id="basic-info-wrapper">
          <div style="margin-bottom: 20px;" class="row filter-wrapper">
            <div class="col searchInput-position">
                <div class="searchInputGroup">
                  <div class="searchIcon">
                    <img src="../../images/new_ui/filter.png">
                  </div>
                  <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                    onblur="this.placeholder='Filter'" [(ngModel)]="searchField" (ngModelChange)="onChange()">
                </div>
            </div>
            <div class="col col-large">
              Invoice Dated From:
              <div class="searchInputGroup">
                <div class="searchIcon" (click)="dateFrom.toggle()">
                  <img src="../../images/new_ui/date.png">
                </div>
                <input id="dateFrom" class="searchInput date-picker" type="text" [(ngModel)]="fromDate" placeholder="Date"
                  mame="datePicker" ngbDatepicker  #dateFrom="ngbDatepicker" (click)="dateFrom.toggle()">
              </div>
            </div>
            <div class="col col-large">
              To:
              <div class="searchInputGroup">
                <div class="searchIcon" (click)="dateTo.toggle()">
                  <img src="../../images/new_ui/date.png">
                </div>
                <input id="dateTo" class="searchInput date-picker" type="text" [(ngModel)]="toDate" placeholder="Date"
                  mame="datePicker" ngbDatepicker #dateTo="ngbDatepicker" (click)="dateTo.toggle()">

              </div>
            </div>
            <div class="col col-small button-position">
              <button class="button button-red button-mid" id="btnFilter" (click)="filterReports();">Apply</button>
            </div>
            <!-- <div class="col col-small">
              <div id="btnDownload" class="basic-icon download-icon download-icon-position" placement="top" ngbTooltip="Download Excel" (click)="downloadReports()"></div>
            </div> -->
          </div>
        </div>

        <div *ngIf="loadContent && subscriptionReports.length > 0 && !hasEmptyFilterResult">
          <div class="shared-outer-wrapper table-header-allign" *ngIf="subscriptionReports?.length">
            <table matSort (matSortChange)="sortData($event)" class="white">
              <thead>
                <tr class="row">
                  <th class="col" style="min-width: 30%;" mat-sort-header="tenantName">TENANT NAME</th>
                  <!-- <th class="col" mat-sort-header="tenantID">TENANT ID</th> -->
                  <th class="col" mat-sort-header="invoiceNo">INVOICE NO</th>
                  <th class="col" mat-sort-header="invoiceDate">INVOICE DATE</th>
                  <th class="col" mat-sort-header="cusReference">CUSTOMER REF</th>
                  <th class="col" mat-sort-header="noOfSubscriptions">SUBSCRIPTIONS</th>
                  <th class="col align-right" mat-sort-header="totalInvoiceAmount" style="max-width: 14%;">TOTAL AMOUNT</th>
                </tr>
              </thead>
            </table>
            <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
              *ngIf="showPager"></pagination-controls> -->
          </div>
          <div class="shared-outer-wrapper child-body subscription-rp" *ngIf="subscriptionReports?.length">
            <table matSort (matSortChange)="sortData($event)" class="white">
              <thead hidden="true">
                <tr class="row">
                  <th class="col" style="min-width: 30%;" mat-sort-header="tenantName">TENANT NAME</th>
                  <!-- <th class="col" mat-sort-header="tenantID">TENANT ID</th> -->
                  <th class="col" mat-sort-header="invoiceNo">INVOICE NO</th>
                  <th class="col" mat-sort-header="invoiceDate">INVOICE DATE</th>
                  <th class="col" mat-sort-header="cusReference">CUSTOMER REF</th>
                  <th class="col" mat-sort-header="noOfSubscriptions">SUBSCRIPTIONS</th>
                  <th class="col align-right" mat-sort-header="totalInvoiceAmount" style="max-width: 14%;">TOTAL AMOUNT</th>
                </tr>
              </thead>
              <tbody class="scrollable-table-body">
                <ng-container>
                  <ng-container *ngFor="let report of sortedData | TableFilterMultiple:['tenantName', 'invoiceNo', 'invoiceDate', 'custReference'] : searchField">
                    <tr class="row">
                      <td class="col-md" style="min-width: 30%;">{{report?.tenantName}}</td>
                      <!-- <td class="col-md">{{report?.tenantID}}</td> -->
                      <td class="col-md">{{report?.invoiceNo}}</td>
                      <td class="col-md">{{report?.invoiceDate}}</td>
                      <td class="col-md">{{report?.custReference}}</td>
                      <td class="col-md align-center">{{report?.noOfSubscriptions}}</td>
                      <td class="col-md align-right padding-r-x25" style="max-width: 14%;">{{report?.totalInvoiceAmount | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
            <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
              *ngIf="showPager"></pagination-controls> -->
          </div>
        </div>

        <div class="inner-subBlock-wrapper" *ngIf="loadContent && azureInvoiceReports.length > 0 && !hasEmptyFilterResult">
            <div class="shared-outer-wrapper table-header-allign" *ngIf="azureInvoiceReports?.length">
              <table matSort (matSortChange)="sortData($event)" class="white">
                <thead>
                  <tr class="row">
                    <th class="col" style="max-width: 8%;" mat-sort-header="invoiceNo">INV NO</th>
                    <th class="col" mat-sort-header="invoiceDate">INVOICE DATE</th>
                    <th class="col" style="max-width: 10%;" mat-sort-header="cusReference">CUST REF</th>
                    <th class="col" mat-sort-header="tenantName">TENANT NAME</th>
                    <!-- <th class="col" mat-sort-header="tenantID">TENANT ID</th> -->
                    <!-- <th class="col" mat-sort-header="subscriptionId">SUBSCRIPTION ID</th> -->
                    <th class="col" mat-sort-header="subscriptionName">SUB NAME</th>
                    <th class="col" style="max-width: 13%;" mat-sort-header="usageStartDate">USAGE START</th>
                    <th class="col" style="max-width: 11%;" mat-sort-header="usageEndDate">USAGE END</th>
                    <th class="col" style="max-width: 8%;" mat-sort-header="totalInvoiceAmount">AMOUNT</th>
                    <th class="col" style="max-width: 3%;"></th>
                  </tr>
                </thead>
              </table>
              <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
                *ngIf="showPager"></pagination-controls> -->
            </div>
            <div class="shared-outer-wrapper child-body azure-rp" *ngIf="azureInvoiceReports?.length">
              <table matSort (matSortChange)="sortData($event)" class="white">
                <thead hidden="true">
                  <tr class="row">
                    <th class="col" style="max-width: 8%;" mat-sort-header="invoiceNo">INV NO</th>
                    <th class="col" mat-sort-header="invoiceDate">INVOICE DATE</th>
                    <th class="col" style="max-width: 10%;" mat-sort-header="cusReference">CUST REF</th>
                    <th class="col" mat-sort-header="tenantName">TENANT NAME</th>
                    <!-- <th class="col" mat-sort-header="tenantID">TENANT ID</th> -->
                    <!-- <th class="col" mat-sort-header="subscriptionId">SUBSCRIPTION ID</th> -->
                    <th class="col" mat-sort-header="subscriptionName">SUB NAME</th>
                    <th class="col" style="max-width: 13%;" mat-sort-header="usageStartDate">USAGE START</th>
                    <th class="col" style="max-width: 11%;" mat-sort-header="usageEndDate">USAGE END</th>
                    <th class="col" style="max-width: 8%;" mat-sort-header="totalInvoiceAmount">AMOUNT</th>
                    <th class="col" style="max-width: 3%;"></th>
                  </tr>
                </thead>
                <tbody class="scrollable-table-body">
                  <ng-container>
                    <ng-container *ngFor="let report of sortedData | TableFilterMultiple:['invoiceNo', 'invoiceDate', 'cusReference', 'tenantName', 'subscriptionName', 'usageStartDate', 'usageEndDate'] : searchField">
                      <tr class="row">
                        <td class="col" style="max-width: 8%;">{{report?.invoiceNo}}</td>
                        <td class="col">{{report?.invoiceDate}}</td>
                        <td class="col" style="max-width: 10%;">{{report?.cusReference}}</td>
                        <td class="col orderNo-wrapper">{{report?.tenantName}}</td>
                        <!-- <td class="col">{{report?.tenantID}}</td> -->
                        <!-- <td class="col">{{report?.subscriptionId}}</td> -->
                        <td class="col">{{report?.subscriptionName}}</td>
                        <td class="col" style="max-width: 13%;">{{report?.usageStartDate}}</td>
                        <td class="col" style="max-width: 11%;">{{report?.usageEndDate}}</td>
                        <td class="col" style="max-width: 8%;">{{report?.totalInvoiceAmount | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                        <td class="col"  style="max-width: 3%;">
                            <div id="downloadBtn{{report?.invoiceNo}}" class="basic-icon download-icon download-icon-margin" placement="top" ngbTooltip="Download Excel" (click)="exportCSPUsageInvoice(report?.invoiceNo, report?.subscriptionId)"></div>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
              <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
                *ngIf="showPager"></pagination-controls> -->
            </div>
          </div>

          <ng-container *ngIf="loadContent && hasEmptyFilterResult">
            <div class="noResult-wrapper">
              <div class="top-divider"></div>
              <div><img src="../images/new_ui/no-found.png"></div>
              <div>No results found</div>
              <div>Sorry, that search or filter combination has no results.<br>Please try different criteria.</div>
              <button (click)="filterReset()" class="button button-red button-large">Try again</button>
              <div class="noResult-feedback">Send feedback</div>
            </div>
            <div class="top-divider"></div>
          </ng-container>

         <div class="inner-subBlock-wrapper" *ngIf="loadContent && !subscriptionReports.length && !azureInvoiceReports.length && !hasEmptyFilterResult">
              <div class="noData-wrapper">
                <div>
                    <img src="../../images/new_ui/no-subscription.png">
                  </div>
                <label class="noData-label">
                    WE COULDN'T FIND ANY <br/>
                    INVOICES FOR GIVEN DATE RANGE
              </label>
              <br/>
              
              </div>
        </div>
      
    </div>
    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>
